/**
 * Barra fija de "Añadir al carrito" para artículos, páginas, colecciones y home.
 * La ficha de producto usa sticky-atc.js, que hereda de <product-form> y sigue a
 * la galería y al selector de variantes. Aquí el producto es fijo, así que basta
 * con envolver un <product-form> normal y controlar la aparición al hacer scroll.
 */
(() => {
  if (customElements.get('sticky-atc-global')) return;

  const HIDDEN_CLASS = 'sticky-atc--out';
  const FOOTER_GAP = 60;

  class StickyAtcGlobal extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.storageKey = this.dataset.storageKey || '';
      if (this.storageKey && this.isDismissed()) {
        this.remove();
        return;
      }

      this.scrollTrigger = parseInt(this.dataset.scrollTrigger, 10) || 60;
      this.footer = document.getElementById('pagefooter');
      this.pinned = false;
      this.ticking = false;

      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });

      const closeBtn = this.querySelector('.sticky-atc__close');
      if (closeBtn) closeBtn.addEventListener('click', this.dismiss.bind(this));

      // En el editor de temas conviene verla siempre que la sección esté seleccionada
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (evt) => {
          if (evt.target.contains(this)) this.pin(true);
        });
        document.addEventListener('shopify:section:deselect', (evt) => {
          if (evt.target.contains(this)) this.pin(false);
        });
      }

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }

    /**
     * Whether the visitor closed the bar earlier in this session.
     * @returns {boolean} - Is dismissed.
     */
    isDismissed() {
      try {
        return sessionStorage.getItem(this.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    /**
     * Shows the bar once past the trigger point, hides it over the footer.
     */
    update() {
      if (this.pinned) return;

      const scrolled = window.scrollY || window.pageYOffset;
      const pastTrigger = scrolled > (window.innerHeight * this.scrollTrigger) / 100;

      let atEnd;
      if (this.footer) {
        atEnd = this.footer.getBoundingClientRect().top < window.innerHeight - FOOTER_GAP;
      } else {
        atEnd = scrolled + window.innerHeight + 120 >= document.documentElement.scrollHeight;
      }

      const hide = !pastTrigger || atEnd;
      this.classList.toggle(HIDDEN_CLASS, hide);
      // Some themes leave a leftover `.invisible` utility on the bar; it would
      // keep visibility:hidden even after sticky-atc--out is removed.
      this.classList.toggle('invisible', hide);
    }

    /**
     * Forces the bar visible (theme editor).
     * @param {boolean} state - Pin or unpin.
     */
    pin(state) {
      this.pinned = state;
      if (state) {
        this.classList.remove(HIDDEN_CLASS);
      } else {
        this.update();
      }
    }

    dismiss() {
      this.classList.add(HIDDEN_CLASS);

      try {
        if (this.storageKey) sessionStorage.setItem(this.storageKey, '1');
      } catch (error) {
        // sessionStorage no disponible (modo privado): se oculta solo esta vez
      }

      setTimeout(() => this.remove(), 300);
    }
  }

  customElements.define('sticky-atc-global', StickyAtcGlobal);
})();
